import React from 'react';
import CCLHeading from '@deliveroo/consumer-component-library/components/Heading';

class Heading extends React.Component {
  validateProps({ level, size, color, text }) {
    return (
      [1, 2, 3, 4].indexOf(level) > -1 &&
      ['large', 'medium', 'small', 'x-small'].indexOf(size) > -1 &&
      ['black', 'white'].indexOf(color) > -1 &&
      text
    );
  }

  componentDidMount() {
    const { level, size, color, text } = this.props;

    if (!this.validateProps({ level, size, color, text })) {
      throw new Error(`Incorrect prop-types for Storyblok Heading component`);
    }
  }

  render() {
    const { level, size, color, text } = this.props;

    return (
      <CCLHeading level={level} size={size} color={color} spacing="medium 0">
        {text}
      </CCLHeading>
    );
  }
}

Heading.propTypes = {
  level: CCLHeading.propTypes.level,
  size: CCLHeading.propTypes.size,
  color: CCLHeading.propTypes.color,
  text: CCLHeading.propTypes.children,
};

Heading.defaultProps = {
  level: CCLHeading.defaultProps.level,
  size: CCLHeading.defaultProps.size,
  color: CCLHeading.defaultProps.color,
  text: CCLHeading.defaultProps.children,
};

export default Heading;
